import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import * as ReactRedux from 'react-redux';
import selectState from 'IowaBENInput/IowaBENInputActions';
import store from 'store';

export class IowaBENInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isVisible = this.isVisible.bind(this);
  }

  isVisible() {
    return this.props.filingState !== null && this.props.filingState.toLowerCase() === 'ia';
  }

  render() {
    return !this.isVisible() ?
    null :
    (
      <React.Fragment>
        <label className="control-label hide-label" htmlFor="payee1_ia_ben">
          Iowa Business eFile Number (BEN)
        </label>
        <div className="controls">
          <input
            type="text"
            className="input-large"
            defaultValue={this.props.value}
            id="payee1_ia_ben"
            name="payee1_ia_ben"
            placeholder="Iowa Business eFile Number (BEN)"
          />
        </div>
      </React.Fragment>
    );
  }
}

IowaBENInput.propTypes = {
  filingState: PropTypes.string,
  value: PropTypes.string,
};

IowaBENInput.defaultProps = {
  filingState: null,
  value: '',
};

const mapStateToProps = ({ IowaBENInputHandler }) => ({
  filingState: IowaBENInputHandler.filingState,
});
const ConnectedIowaBENInput = ReactRedux.connect(
  mapStateToProps,
)(IowaBENInput);

ConnectedIowaBENInput.init = (props, id) => {
  const elementId = id || 'group_payee1_ia_ben';
  ReactDOM.render(
    <ReactRedux.Provider store={store}>
      <ConnectedIowaBENInput {...props} />
    </ReactRedux.Provider>,
    document.getElementById(elementId),
  );
};

if (window.FormSwift && window.FormSwift.React) {
  const newActions = Object.assign({}, window.FormSwift.React.actions, { selectState });
  window.FormSwift.React.actions = newActions;
} else {
  window.FormSwift = {
    React: {
      store,
      actions: { selectState },
    },
  };
}

export default ConnectedIowaBENInput;



// WEBPACK FOOTER //
// ./src-react/IowaBENInput/index.jsx